import { Component, Input, OnInit } from '@angular/core';
import { FiltroService } from './../../../../shared/filtro/filtro.service';

@Component({
  selector: 'app-estoque-amp-filtro',
  templateUrl: './estoque-amp-filtro.component.html',
  styleUrls: ['./estoque-amp-filtro.component.css']
})
export class EstoqueAmpFiltroComponent implements OnInit {

  @Input() filtros: any;

  constructor(private servico: FiltroService) { }

  dealers = [];

  ngOnInit() {
    this.preencherDealers();
  }

  preencherDealers() {
      this.servico.buscar('dealer')
        .then(r => { this.dealers = r.filtros; });
  }
  set Dealer(id: any) { this.filtros.dealer = this.tratarSetDropDown(id); }
  get Dealer(): any { return this.tratarGetDropDown(this.filtros.dealer); }

  
  tratarSetDropDown(id: string): number {
    if (id) {
      return +id;
    } else {
      return null;
    }
  }

  tratarGetDropDown(selecionado: any): string {
    if (selecionado === null || selecionado === undefined) {
      return '';
    }
    return selecionado;
  }


  selecionaDealer() {
    this.dealers = [];

    this.preencherDealers();
  }

  limparFiltros() {
    this.filtros.id = '';
    this.filtros.dealer = '';
    this.filtros.descricao = '';
    this.filtros.quantidade = '';
  }

}
